import axiosInstance from './axiosInstance';
import DMGetApplicationConfigResponse from './interfaces/DMGetApplicationConfigResponse';

const getAppConfigData = (configUrl: string) => axiosInstance
  .get<DMGetApplicationConfigResponse>(configUrl);

export {
  getAppConfigData,
};
